import { TAssetSource } from "@rentiohq/web-shared/dist/components";

export enum EAdministrationItems {
  // entry items
  Index = "index",
  Contract = "contract",
  Sign = "sign",
  Deposit = "deposit",
  Rent = "rent",
  PropertyInspectionReport = "property_inspection_report",
  FireInsurance = "fire_insurance",
  MijnVerhuis = "mijn_verhuis",
  Energy = "energy",
  Register = "register",
  BrusselsRegistration = "brussels_registration",

  // exit items
  DepositRelease = "deposit_release",
  OutstandingPayments = "outstanding_payments",
  OutgoingPropertyInspectionReport = "outgoing_property_inspection_report",
  OutgoingMove = "outgoing_move",

  // extra
  Extra = "extra",
}

export enum EStatus {
  None,
  Success,
  Warning,
  Error,
}

export interface IAdministrationItem {
  id: EAdministrationItems;
  label: string;
  icon: TAssetSource;
  status: EStatus;
  tooltip?: string | JSX.Element[];
  link?: string;
  onClick?: () => void;
}
